import { ReactNode } from 'react';
import './MobileAppSection.css';
import MobileMockup from './MobileMockup';

interface MobileAppSectionProps {
  title?: ReactNode;
  subtitle?: ReactNode;
}

export default function MobileAppSection({ title, subtitle }: MobileAppSectionProps = {}) {
  return (
    <section className="mobile-app-section">
      <div className="mobile-app-container">
        <div className="mobile-app-content">
          <h2 className="mobile-app-title">
            {title ?? (
              <>Take Your Cosmic Journey <br />Anywhere</>
            )}
          </h2>
          <p className="mobile-app-subtitle">
            {subtitle ?? (
              <>Access personalized horoscopes, birth chart readings, and cosmic guidance right from your pocket. Our mobile app brings the universe to your fingertips.</>
            )}
          </p>
          <div className="coming-soon-text">APP LIVE NOW</div>
          <div className="app-rating">
            <span className="app-rating-stars" aria-hidden="true">★★★★★</span>
            <span className="app-rating-text">
              <strong>4.4</strong> on Google Play · 1M+ downloads
            </span>
          </div>
          <div className="store-buttons">
            <button
              className="store-button app-store"
              disabled
              title="iOS app coming soon"
              aria-label="App Store version coming soon"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              {/* The label says "Coming soon", not "Download on the". The button
                  is disabled because there is no iOS app yet, but it previously
                  still read "Download on the App Store", so it looked broken
                  rather than upcoming. ProductSchema also declares
                  operatingSystem "Android, Web" for the same reason: do not
                  imply an iOS app that does not exist. */}
              <div className="store-text">
                <span className="store-label">Coming soon on the</span>
                <span className="store-name">App Store</span>
              </div>
            </button>
            
            {/* UPDATED: Converted to Anchor tag for best practice */}
            <a 
              href="https://play.google.com/store/apps/details?id=com.astroaura.auraai"
              target="_blank" 
              rel="noopener noreferrer"
              className="store-button google-play"
              style={{ textDecoration: 'none' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.802 8.99l-2.303 2.303-8.635-8.635z"/>
              </svg>
              <div className="store-text">
                <span className="store-label">Get it on</span>
                <span className="store-name">Google Play</span>
              </div>
            </a>
            
          </div>
        </div>
        <div className="mobile-app-mockup">
          <MobileMockup />
        </div>
      </div>
    </section>
  );
}